var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-left" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("message.login.reset_password")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("message.login.reset_password_detail")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            staticClass: "form-control input-lg",
            class: { "form-alert": _vm.errorEmail },
            attrs: {
              type: "email",
              placeholder: _vm.$t("message.login.email")
            },
            domProps: { value: _vm.email },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                },
                function($event) {
                  return _vm.updateFormData("email", $event)
                }
              ]
            }
          }),
          _vm._v(" "),
          _vm.errorEmail
            ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                _vm._v(_vm._s(_vm.errorEmailText) + "\n        ")
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "button",
          {
            staticClass: "button-large button-block -cyan",
            on: { click: _vm.checkEmailAccount }
          },
          [_vm._v("\n        " + _vm._s(_vm.isSendingEmail) + "\n      ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-12 text-left back-link" }, [
        _c(
          "a",
          {
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.backToLogin.apply(null, arguments)
              }
            }
          },
          [
            _c("i", { staticClass: "far fa-angle-left" }),
            _vm._v(
              " " + _vm._s(_vm.$t("message.login.back_to_login")) + "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ee3d9c8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3d9c8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/ResetPasswordForm.vue
// module id = 1394
// module chunks = 0